(() => {
    const loadState = () => {
        const addr = localStorage.getItem('address');
        const addr2 = localStorage.getItem('address2');
        const city = localStorage.getItem('city');
        const stateAbbr = localStorage.getItem('state');
        const zip = localStorage.getItem('zip');
        const hasAppliedRebates = localStorage.getItem('applyrebatesbtn_disable') == 'true';
        const hasRemovedCartItems = localStorage.getItem('containsUESItemsAndisNotAllowedZip') === 'true';
        const rebates_unavailable = localStorage.getItem('rebates_unavailable');
        const unavailableRebates = typeof rebates_unavailable == 'string'
            ? JSON.parse(rebates_unavailable)
            : {};
        return {
            addr,
            addr2,
            city,
            stateAbbr,
            zip,
            hasAppliedRebates,
            unavailableRebates,
            hasRemovedCartItems,
        };
    };
    const render = (state) => {
        const { addr, city, hasAppliedRebates, hasRemovedCartItems, unavailableRebates = {}, } = state;
        const canCheckout = !(addr == null || city == null || addr == '' || city == '');
        // Enable and/or disable rebate and checkout buttons
        $('#applyrebates').prop('disabled', hasAppliedRebates);
        $('#cart_to_checkout').prop('disabled', !canCheckout || !hasAppliedRebates);
        // Show removed item message if needed
        if (hasRemovedCartItems) {
            $('#removedCartItemsModal').show();
        }
        // Populate unavailable rebate info
        for (const key in unavailableRebates) {
            const value = unavailableRebates[key];
            if (value !== '') {
                $('#' + key).text(value);
            }
        }
    };
    $(() => {
        const state = loadState();
        render(state);
        // When user clicks on (x) button, re-render the UI
        $('.close').on('click', () => {
            render(state);
        });
        $('#cart_to_checkout').on('click', () => {
            window.location.href = `/checkout?checkout[shipping_address][address1]=${state.addr}&checkout[shipping_address][address2]=${state.addr2}&checkout[shipping_address][city]=${state.city}&checkout[shipping_address][province]=MI&checkout[shipping_address][zip]=${state.zip}`;
        });
        // This is weird cruft that's still needed but needs to be refactored
        localStorage.removeItem('containsUESItemsAndisNotAllowedZip');
    });
})();
